module.exports = __webpack_public_path__ + "static/media/portal_screenshot_mini.d63ef516.png";